import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { EstadoRol } from '../_models/estado-rol';

@Injectable({
  providedIn: 'root'
})
export class EstadoRolService {
  private rutServicio = AppSettings.rutServiciosASI + '/api/estadosRoles';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as EstadoRol[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as EstadoRol[] ) );
  }

  listadoPorEstado( idEstado: string ) {
    return this.httClient.get( this.rutServicio + '/estado/' + idEstado ).pipe( map( res => res as EstadoRol[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as EstadoRol ) );
  }

  listadoComite() {
    return this.httClient.get( this.rutServicio + '/estado/indicadorComite/enabled' ).pipe( map( res => res as EstadoRol[] ) );
  }

  crear( regCrear: EstadoRol ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as EstadoRol ) );
  }

  actualizar( regActualizar: EstadoRol ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as EstadoRol ) );
  }


}
